import { render, staticRenderFns } from "./updateLivechat.vue?vue&type=template&id=256c01ca&scoped=true&lang=pug"
import script from "./updateLivechat.vue?vue&type=script&lang=js"
export * from "./updateLivechat.vue?vue&type=script&lang=js"
import style0 from "./updateLivechat.vue?vue&type=style&index=0&id=256c01ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256c01ca",
  null
  
)

export default component.exports